import React from 'react';

const Dashboard = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Dashboard</h1>
        <p className="text-lg text-gray-600 mb-6">This page is coming soon. Stay tuned!</p>
        <div className="animate-pulse text-sm text-gray-500">We’re working hard to bring this to you.</div>
      </div>
    </div>
  );
};

export default Dashboard;
